import Axios from "axios";
import { getDomain } from "../../../Utilities/utils";
import { CREATE_QUOTE_CONFIG_ENDPOINT } from "../../apiConfig";

/** Get config json to build form */
export default async function getConfigJson(productRef, transferDataId) {
  const domain = getDomain();

  try {
    const response = await Axios.post(
      `${domain}${CREATE_QUOTE_CONFIG_ENDPOINT}/${productRef}/${transferDataId}/`
    );
    if (response.status === 200) {
      console.log("config json response", response);
      return response.data;
    }
    return null;
  } catch (error) {
    alert(error);
    return null;
  }
}
